import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouteError } from "react-router";
import { selectError, setError } from "./slices/errorSlice";
import { normalizeError } from "./utils/error-handling";

const ErrorPage = () => {
	const error = useRouteError();
	// oxlint-disable-next-line no-console
	console.error(error);
	const errorModal = useSelector(selectError);
	const dispatch = useDispatch();

	useEffect(() => {
		if (!errorModal.errorMsg) {
			dispatch(setError(normalizeError(error)));
		}
	}, []);

	return null;
};

export default ErrorPage;
